import axios from 'axios';
angular.module('leanlaw').controller('MattersCreateCtrl', ['$filter', '$scope', '$http', '$state', '$stateParams', 'matterManager', 'clientMatterOptionsService', 'userService', 'alerts', 'accountingService', 'leanLawApi', 'lists', 'chargeManager', 'matterTagsService', 'netDocsStatusService', function ($filter, $scope, $http, $state, $stateParams, matterManager, clientMatterOptionsService, userService, alerts, accountingService, leanLawApi, lists, chargeManager, matterTagsService, netDocsStatusService) {
  $scope.ratePlaceholder = 'Pick or Enter Rate';
  $scope.fixedPlaceholder = 'Pick or Enter Fee';
  $scope.helpClients = false;
  $scope.standard = {};
  $scope.domain = leanLawApi.domain;
  $scope.matterCount = 0;
  $scope.matterCopyInfo = {};
  $scope.rateGroups = [];
  $scope.clientQuery = {
    originating: false,
    involved: false,
    reviewer: false,
    primary: false,
    scopeAccount: $state.filter?.scopeAccount,
    status: '',
    archived: false,
    showOrphans: true
  };
  $scope.matterQuery = {
    originating: false,
    involved: false,
    reviewer: false,
    primary: false,
    scopeAccount: $state.filter?.scopeAccount,
    status: '',
    archived: false,
    clientId: null
  };
  activate();
  $scope.searchMatters = searchMatters;
  $scope.setMatterID = setMatterID;
  $scope.clientSelected = clientSelected;
  $scope.rateGroupChanged = rateGroupChanged;
  $scope.existingMatterSelected = function (matter) {
    matter.testAccess().then(() => {
      done(false);
    }).catch(prompt => {
      bootbox.confirm(prompt, result => {
        if (!result) return;
        if (!matter.active || !matter.involved) {
          matter.assign().then(() => {
            done(matter);
          });
        } else {
          done(false);
        }
      });
    });
  };
  $scope.rateLabel = function (rate) {
    return `${rate.label} (${$filter('currency')(rate.amount, '$', 0)})`;
  };
  $scope.showCopyBilling = function () {
    return $scope.matter.client?.id && $scope.matterCount > 0;
  };
  $scope.contingencyFeeError = function () {
    if ($scope.billingType !== 'contingency') return '';
    const val = $scope.contingency.feePercentage;
    if (val == null || val === '') return '';
    if (val < 0 || val > 100) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    if (val !== 0 && val < 0.00000001) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    const parts = String(val).split('.');
    if (parts[1] && parts[1].length > 8) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    return '';
  };
  $scope.isContingencyFeeInvalid = function () {
    return $scope.billingType === 'contingency' && !!$scope.contingencyFeeError();
  };
  $scope.assignMatterToScope = assignMatterToScope;

  /////////////////////////////

  let _search;
  async function activate() {
    const me = await userService.me();
    $scope.me = me;
    $scope.matter = Object.assign($scope.matter || {}, $stateParams.matter || {}, {
      opened: new Date(),
      billing: {
        type: ''
      },
      originatingId: '',
      primaryId: ''
    });
    if ($stateParams.clientId) {
      $scope.matter.client = {
        id: $stateParams.clientId
      };
      updateSearch();
    }
    if ($stateParams.matter && $stateParams.matter.client) {
      updateSearch();
    }
    $scope.billingType = 'hours';
    $scope.contingency = {
      feePercentage: 33.33333333
    };
    userService.list().then(users => {
      $scope.users = users.filter(u => u.role !== 'timekeeper' && u.role !== 'accountant');
      $scope.users.sort((a, b) => a.name.localeCompare(b.name));
      // Prefill only once the roster is known. A role the roster excludes
      // (accountant, timekeeper) can't hold Responsible, so leave it empty
      // for them rather than seeding a value the dropdown can't offer.
      $scope.matter.primary = defaultPrimary();
    });
    await getRateGroup();
    if (me.features.netdocs) {
      checkNetDocsStatus();
    }
    matterTagsService.getMatterTags().then(mattertags => {
      $scope.matterTags = mattertags;
      $scope.matter.matterTag = $scope.matterTags.find(t => t.default);
    });
    $scope.rate = _.find(me.rateList, r => r.label === 'Standard');
    $scope.types = lists.billingTypes;
    chargeManager.listStandard().then(standard => {
      $scope.standardCharges = standard.select;
      $scope.standardCharges.sort((a, b) => {
        a.display = a.label || a.description;
        b.display = b.label || b.description;
        return a.display.localeCompare(b.display);
      });
    });
  }
  async function checkNetDocsStatus() {
    await netDocsStatusService.checkStatus();
    $scope.netDocsStatus = netDocsStatusService.state;
  }
  async function getRateGroup() {
    try {
      const path = `${$scope.domain}/rategroups?format=settings`;
      const {
        data
      } = await $http.get(path);
      $scope.rateGroups = data.map(group => {
        return {
          id: group.rateGroupId,
          name: group.name,
          default: group.default
        };
      });
      $scope.matter.rateGroup = {};
      $scope.matter.rateGroup.rateGroupId = $scope.rateGroups.find(rateGroup => rateGroup.default)?.id;
    } catch (error) {
      alerts.error(error?.response?.data?.message);
    }
  }
  $scope.cancel = function () {
    $state.go('^');
  };
  function done(created, redirectToNewCharge) {
    if (!created) {
      return;
    }
    // reload accounting clients because we will flag quickbooks as unknown
    accountingService.clients(true);
    const rawRoot = $state.current.name.split('.')[0];
    // The bare `matters` root (sc-46278) has no client/matter detail
    // hierarchy of its own - reuse matters-next's, same as CreateMatter.vue
    // (the Vue equivalent of this legacy form) already does.
    const root = rawRoot === 'matters' ? 'matters-next' : rawRoot;
    if (redirectToNewCharge) {
      return $state.go(`${root}.client.matter.fixed.charge`, {
        id: created.client?.id,
        matterId: created.id
      });
    }
    if ($scope.entry || $scope.expense) {
      if ($scope.matterCreated) {
        $scope.matterCreated(created);
      }
      return $state.go('^');
    }
    return $state.go(`${root}.client.matter.info`, {
      id: created.client?.id,
      matterId: created.id
    });
  }
  function missingRequiredFields() {
    const missing = [];
    if (!$scope.matter.client) {
      missing.push('Client');
    }
    if (!$scope.matter.name || !$scope.matter.name.replace(/ /g, '')) {
      missing.push(`${$scope.me.terms.Matter} name`);
    }
    if (!($scope.matter.primary && $scope.matter.primary.id)) {
      missing.push('Responsible');
    }
    if ($scope.me.company.settings.requireOriginating && !($scope.matter.originating && $scope.matter.originating.id)) {
      missing.push(`Originating ${$scope.me.terms.lead}`);
    }
    return missing;
  }
  $scope.save = function (redirectToNewCharge) {
    if (!$scope.matterForm.$valid) {
      return;
    }
    // Checked before the payload is assembled so an incomplete form never
    // reaches the server - otherwise the backend's own default-assignment
    // fallback decides who ends up Responsible.
    const missing = missingRequiredFields();
    if (missing.length) {
      alerts.error(`These fields are required: ${missing.join(', ')}`);
      return;
    }
    $scope.matter.billing.type = $scope.billingType;
    if ($scope.billingType === 'charge') {
      $scope.matter.billing.type = 'hours';
    }
    if ($scope.billingType === 'contingency') {
      $scope.matter.contingencyFeePercentage = $scope.contingency.feePercentage || null;
    } else {
      $scope.matter.contingencyFeePercentage = null;
    }
    if ($scope.matter.opened === undefined) {
      $scope.matter.opened = new Date();
    }
    if ($scope.matter.primary || $scope.rate) {
      $scope.matter.users = [];
      const primaryId = $scope.matter.primary && $scope.matter.primary.id;
      if (primaryId && primaryId !== $scope.me.id) {
        $scope.matter.users.push({
          id: primaryId,
          primary: true
        });
      }
      const mePrimary = primaryId === $scope.me.id;
      if ($scope.rate || mePrimary) {
        $scope.matter.users.push({
          id: $scope.me.id,
          primary: mePrimary,
          rate: $scope.rate
        });
      }
    }
    if ($scope.matter.originating && $scope.matter.originating.id) {
      $scope.matter.users = $scope.matter.users || [];
      let user = $scope.matter.users.find(u => u.id === $scope.matter.originating.id);
      if (!user) {
        user = {
          id: $scope.matter.originating.id
        };
        $scope.matter.users.push(user);
      }
      user.originating = true;
    }

    // If the reference is the default that came back from the call to getMyCompanyReferences
    // we should set the reference to null because it gets set by the backend
    $scope.matter.reference = $scope.reference === $scope.nextReference ? null : $scope.reference;
    $scope.loading = true;
    return matterManager.create($scope.matter).then(matter => {
      if ($scope.billingType == 'fixed') {
        if ($scope.standard.charge) {
          return chargeManager.addStandardToMatter(matter, $scope.standard.charge).then(() => done(matter, redirectToNewCharge));
        }
        if ($scope.charge) {
          return chargeManager.create(matter, $scope.charge).then(() => done(matter, redirectToNewCharge));
        }
      }
      done(matter, redirectToNewCharge);
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  };
  async function assignMatterToScope(matter) {
    // called by child controller when creating a new client
    $scope.matter = matter;
    if (matter.client?.id) {
      var client = await clientMatterOptionsService.getClient(matter.client.id);
      $scope.matter.client = client;
      updateSearch();
    }
  }
  function rateGroupChanged() {}

  /**
   * Remove matter ID if client was removed, watch for change to matter.client. For better UI experience.
   */
  $scope.$watch('matter.client', (newVal, oldVal) => {
    if (!$scope.matter.client) {
      $scope.matter.reference = '';
    }
    if (newVal?.id && newVal?.id !== oldVal?.id) {
      clientSelected();
    }
  });
  function clientSelected() {
    if ($scope.matter.client) {
      $scope.matterQuery.clientId = $scope.matter.client.id;
      clientMatterOptionsService.getMatterCount($scope.matterQuery).then(response => {
        $scope.matterCount = response;
        $http.get(`${$scope.domain}/matters/copy?clientId=${$scope.matter.client.id}`).then(response => {
          if (response.data) {
            $scope.matterCopyInfo = response.data;
          }
          if ($scope.matter.copy) {
            if (!$scope.matterCount) {
              $scope.matter.copy = false;
            }
            $scope.toggleCopy();
          }
          $scope.copyLoading = false;
        });
      });
    }
    updateSearch();
  }
  function defaultPrimary() {
    return ($scope.users || []).find(u => u.id === $scope.me.id) || null;
  }
  function restoreUserDefaults() {
    $scope.matter.primary = defaultPrimary();
    $scope.matter.originating = null;
  }
  $scope.toggleCopy = function () {
    if ($scope.matter.copy) {
      // || null, not undefined: a copied attorney who has since left the
      // roster (or changed to a role that can't hold the seat) has to read as
      // empty so the required-field guard catches it instead of posting a blank.
      $scope.matter.originating = ($scope.users || []).find(x => x.id === $scope.matterCopyInfo.originatorId) || null;
      $scope.matter.primary = ($scope.users || []).find(x => x.id === $scope.matterCopyInfo.primaryId) || null;
      $scope.matter.rateGroup.rateGroupId = $scope.rateGroups.find(rateGroup => rateGroup.id === $scope.matterCopyInfo.rateGroupId)?.id;
      $scope.billingType = $scope.types.find(x => x.id === $scope.matterCopyInfo.billingType)?.id;
      $scope.rate = $scope.matterCopyInfo.rate ? {
        amount: $scope.matterCopyInfo.rate,
        label: $scope.matterCopyInfo.rateType || 'Standard'
      } : null;
      $scope.contingency.feePercentage = $scope.matterCopyInfo.contingencyFeePercentage ?? 33.33333333;
    } else {
      restoreUserDefaults();
      $scope.matter.rateGroup.rateGroupId = $scope.rateGroups.find(rateGroup => rateGroup.default)?.id;
      $scope.contingency.feePercentage = 33.33333333;
    }
  };
  function updateSearch() {
    $scope.matterQuery.clientId = $scope.matter.client?.id;
    setMatterID(); //When client is selected set the matter ID.
  }
  function searchMatters(name, prop = 'name') {
    name = name.toLowerCase();
    if ($scope.matter.client) {
      $scope.matterQuery.clientId = $scope.matter.client.id;
    }
    return clientMatterOptionsService.listMatterOptions($scope.matterQuery).then(result => {
      const dictionary = {};
      return result.reduce((acc, m) => {
        const val = m[prop]?.toLowerCase();
        if (val && val.indexOf(name) !== -1 && !dictionary[val]) {
          dictionary[val] = true;
          acc.push(m);
        }
        return acc;
      }, []);
    });
  }
  function setMatterID() {
    $scope.loadingReference = true;
    leanLawApi.getMyCompanyReferences({
      clientId: $scope.matter.client.id
    }).then(result => {
      $scope.nextReference = result.nextMatterReference;
      $scope.reference = $scope.nextReference;
      $scope.loadingReference = false;
    });
  }
}]);